import { DashboardLkDesktop } from './dashboard-lk-page-desktop'
import { DashboardLkMobile } from './dashboard-lk-page-mobile'

export function DashboardLkPage() {
  return (
    <section className="flex w-full flex-col">
      <DashboardLkDesktop />
      <DashboardLkMobile />
    </section>
  )
}
